import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Form, Modal, Skeleton, Timeline, Upload } from 'antd'
import React, { useEffect, useState } from 'react'
import { AiOutlineAlert, AiOutlineCalendar, AiOutlineCheck, AiOutlineCheckCircle, AiOutlineCheckSquare, AiOutlineClose, AiOutlineForm, AiOutlineHourglass } from 'react-icons/ai'
import { useFetch } from '../../../services/ApiService';
import { formatDate, timeFormate, timeFormate12 } from '../../Utility/Functions';
import { Link } from 'react-router-dom';
import { HiOutlineCheckBadge } from 'react-icons/hi2';

function ApplicationHistory({ applicationData, refreshData }) {

  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { fetchApi } = useFetch();
  const [statusId, setStatusId] = useState(0);

  const handleClose = () => {
    setShowModal(false);
  }

  const handleModal = (id) => {
    setStatusId(id);
    applicationData.history_flag = true;
    setShowModal(true);

  }



  const getData = async (applicationId) => {
    setLoading(true);
    await fetchApi(`/api/applicationstatus?application_id=${applicationId}`, 'GET', {}, {
      "x-api-key": "ABCD-123"
    }).then(res => {

      const tempObj = {
        status: 'created',
        createdAt: res[res.length - 1].createdAt,
        modified_by: res[res.length - 1].modified_by,


      }
      res.push(tempObj);
      if (res.length > 3) {
        const tempRes = res.map(item => {
          return { ...item, change_decision: false }
        })

        setData(tempRes);
      }
      else {
        setData(res);
      }

    }).catch(err => {
      console.log(err);
    })
    setLoading(false);
  }

  const getItemIcon = (status) => {
    if (status === 'completed') {
      return <AiOutlineCheck color='#00BA13' size={20} className='me-3' />
    }
    else if (status === 'confirmed') {
      return <AiOutlineCheckSquare color='#3a5a40' size={20} className='me-3' />
    }
    else if (status === 'pending') {
      return <AiOutlineHourglass color='#848484' size={20} className='me-3' />
    }
    else if (status === 'approved') {
      return <AiOutlineCheckCircle color='#39E2D8' size={20} className='me-3' />
    }
    else if (status === 'rejected') {
      return <AiOutlineClose color='#E82A2A' size={20} className='me-3' />
    }
    else if (status === 'scheduled') {
      return <AiOutlineCalendar color='#2662FC' size={20} className='me-3' />
    }
    else if (status === 'created') {
      return <AiOutlineForm size={20} className='me-3' />
    }
  }

  const getItemStatus = (record) => {
    if (record.status === 'pending') {
      return <>
        <h5 className='mb-1'>Application Pending</h5>
        <span className='text-muted h6 fw-regular mb-2 d-block'>{record.modified_by !== 'null null' && record.modified_by}</span>
      </>
    }
    if (record.status === 'completed') {
      return <>
        <h5 className='mb-1'>Exam Completed</h5>
        <span className='text-muted h6 fw-regular mb-2 d-block'>{record.modified_by !== 'null null' && record.modified_by}</span>
      </>
    }
    if (record.status === 'confirmed') {
      return <>
        <h5 className='mb-1'>Exam Result Confirmed</h5>
        <span className='text-muted h6 fw-regular mb-2 d-block'>{record.modified_by !== 'null null' && record.modified_by}</span>
      </>
    }
    else if (record.status === 'scheduled') {
      return <>
        <h5 className='mb-1'>Exam Scheduled</h5>
        <span className='text-muted h6 fw-regular mb-2 d-block'>{record.modified_by !== 'null null' && record.modified_by}</span>
      </>
    }
    else if (record.status === 'created') {
      return <>
        <h5 className='mb-1'>Application Created</h5>
      </>
    }
    else if (record.status === 'approved') {
      return <>
        <h5 className='mb-1'>Application Approved</h5>
        <span className='text-muted h6 fw-regular mb-2 d-block'>{record.modified_by}</span>

        

      </>

    }
    else if (record.status === 'rejected') {
      return <>
        <h5 className='mb-2'>Application Rejected</h5>
        <span className='text-dark h6 fw-regular mb-2 d-block'>{record.comment}</span>
        <span className='text-muted h6 fw-regular mb-2 d-block'>By {record.modified_by}</span>

        {record.attachment_url !== "" || record.attachment_url !== null && 
          <Link target='_blank' to={record.attachment_url} download>
            <Button type='primary' icon={<DownloadOutlined />}>Download Attachment</Button>
          </Link>
        }
        

      </>
    }
  }

  useEffect(() => {
    getData(applicationData.id);
  }, [])

  return (
    <>
      <Skeleton loading={loading}>
        {data.length > 0 ?
          <Timeline
            mode='left'

            className='mb-5'
            items={data.map(item => {
              return {
                label: <div style={{ position: 'relative', transform: 'translateY(25px)' }}>
                  <h5 className='mb-0'>{item.status === 'created' ? formatDate(item.createdAt) : formatDate(item.updatedAt)}</h5>
                  <span className='text-muted'>{item.status === 'created' ? timeFormate12(item.createdAt) : timeFormate12(item.updatedAt)}</span>
                </div>,
                children: <div className='history-content d-flex align-items-start'>
                  <div>
                    {getItemIcon(item.status)}
                  </div>
                  <div>
                    {getItemStatus(item)}
                  </div>
                </div>
              }
            })}
          
          />
          :
          <h5 className='text-center py-5'>History is not available</h5>
        }
      </Skeleton>
      
    </>
  )
}

export default ApplicationHistory